import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Radio, Select, Space } from 'antd';
import { isLinux, PlatformUtil } from 'utils/platform';
import { SummaryHeadDataType } from 'utils/constants/summary-head-data-type';
import style from './SummaryHead.scss';
import { CsNewTabs } from 'components/antd-extension/CsNewTabs';
import { ze } from 'utils/zhEn';
import { ix } from 'utils/i18n-with-context';

const SummaryHead = ({
  appId,
  pid,
  handleChangeSearchParam,
  headDataType,
  pageType,
}) => {
  const { t } = useTranslation();
  const options = [
    ...(isLinux(pid, appId) ? [{ label: ze('异常概览', 'Overview'), value: SummaryHeadDataType.linuxDefault }] : []),
    ...(PlatformUtil.hasAccessStats(pid) ? [{ label: ix(t('EXCP_OVERVIEW.crashUserToday')), value: SummaryHeadDataType.userRate }] : []),
    ...((PlatformUtil.hasAccessStats(pid) && !isLinux(pid, appId)) ? [{ label: ix(t('EXCP_OVERVIEW.sessionCrashRateToday')), value: SummaryHeadDataType.sessionCrashRate }] : []),
    { label: ix(t('EXCP_OVERVIEW.occurNum')), value: SummaryHeadDataType.crashNum },
    { label: ix(t('EXCP_OVERVIEW.userNum')), value: SummaryHeadDataType.crashUser },
  ];

  return <CsNewTabs options={options} value={headDataType} onChange={(value) => handleChangeSearchParam('headDataType', value)} />;
};

SummaryHead.propTypes = {
  handleChangeSearchParam: PropTypes.func,
  headDataType: PropTypes.string,
};

export default SummaryHead;
